import { useMutation } from 'react-query';
import message from 'antd/es/message';

import { request } from 'utils';
import { updateUserDetailQuery } from 'hooks';

import { SnsType } from '../types';

export const useSnsAdd = (address: string) => {
  const res = useMutation(
    ({ type, ...rest }: { type: SnsType }) => {
      const addType = type === SnsType.EMAIL ? 'bind_email' : 'bind_twitter';
      return request.post<{ is_success: boolean }>(`/user/${addType}`, rest, {
        timeout: 20000,
      });
    },
    {
      onSuccess(res, { type, ...rest }) {
        if (!res.is_success) {
          // eslint-disable-next-line
          throw 'add failed';
        }

        updateUserDetailQuery({
          id: address,
          ...rest,
        });

        message.success('added');
      },
    },
  );

  return res;
};

export const useSnsDelete = (address: string) => {
  const res = useMutation(
    ({ type }: { type: SnsType }) => {
      const deleteType = type === SnsType.EMAIL ? 'delete_email' : 'delete_twitter';

      return request.post<{ is_success: boolean }>(`/user/${deleteType}`);
    },
    {
      onSuccess(res, { type }) {
        if (!res.is_success) {
          // eslint-disable-next-line
          throw 'delete failed';
        }
        const idKey = type === SnsType.EMAIL ? 'email' : `${type}_id`;
        const verifyKey = type === 'email' ? 'email_verified' : `${type}_id_verified`;

        updateUserDetailQuery({
          id: address,
          [idKey]: null,
          [verifyKey]: null,
        });

        message.success('deleted');
      },
    },
  );

  return res;
};

export const useSnsVerify = (address: string) => {
  const res = useMutation(
    ({ type, ...rest }: { type: SnsType; verify_code?: string }) => {
      const verifyType = type === SnsType.EMAIL ? 'verify_email' : 'verify_twitter';

      return request.post<{ is_success: boolean }>(`/user/${verifyType}`, rest, {
        timeout: 20000,
      });
    },
    {
      onSuccess(res, { type }) {
        if (!res.is_success) {
          // eslint-disable-next-line
          throw 'Fail to verify';
        }

        const key = type === 'email' ? 'email_verified' : `${type}_id_verified`;
        updateUserDetailQuery({
          id: address,
          [key]: true,
        });
        message.success('verified');
      },
    },
  );

  return res;
};
